/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speechmatics_Target_Language_RussianInputs */

const en_speechmatics_target_language_russian = /** @type {(inputs: Speechmatics_Target_Language_RussianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Russian`)
};

const fr_speechmatics_target_language_russian = /** @type {(inputs: Speechmatics_Target_Language_RussianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Russe`)
};

const de_speechmatics_target_language_russian = /** @type {(inputs: Speechmatics_Target_Language_RussianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Russisch`)
};

const it_speechmatics_target_language_russian = /** @type {(inputs: Speechmatics_Target_Language_RussianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`russo`)
};

const ru_speechmatics_target_language_russian = /** @type {(inputs: Speechmatics_Target_Language_RussianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Русский`)
};

const es_speechmatics_target_language_russian = /** @type {(inputs: Speechmatics_Target_Language_RussianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ruso`)
};

const zh_cn2_speechmatics_target_language_russian = /** @type {(inputs: Speechmatics_Target_Language_RussianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`俄语`)
};

const ja_speechmatics_target_language_russian = /** @type {(inputs: Speechmatics_Target_Language_RussianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ロシア`)
};

const hi_speechmatics_target_language_russian = /** @type {(inputs: Speechmatics_Target_Language_RussianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रूसी`)
};

const pt_pt2_speechmatics_target_language_russian = /** @type {(inputs: Speechmatics_Target_Language_RussianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`russo`)
};

/**
* | output |
* | --- |
* | "Russian" |
*
* @param {Speechmatics_Target_Language_RussianInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speechmatics_target_language_russian = /** @type {((inputs?: Speechmatics_Target_Language_RussianInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speechmatics_Target_Language_RussianInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_speechmatics_target_language_russian(inputs)
	if (locale === "de") return de_speechmatics_target_language_russian(inputs)
	if (locale === "it") return it_speechmatics_target_language_russian(inputs)
	if (locale === "ru") return ru_speechmatics_target_language_russian(inputs)
	if (locale === "es") return es_speechmatics_target_language_russian(inputs)
	if (locale === "zh-CN") return zh_cn2_speechmatics_target_language_russian(inputs)
	if (locale === "ja") return ja_speechmatics_target_language_russian(inputs)
	if (locale === "hi") return hi_speechmatics_target_language_russian(inputs)
	if (locale === "pt-PT") return pt_pt2_speechmatics_target_language_russian(inputs)
	return en_speechmatics_target_language_russian(inputs)
});